module.exports = __webpack_public_path__ + "static/media/seclgroup.7bcfabf6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/seclgroup.webp
// module id = 708
// module chunks = 0